export default __webpack_public_path__ + "static/media/google.0d7a12ee.svg";